<template>
  forwarding...
</template>

<script>

import userService from "@/services/user.service";

export default {
  created() {
    if (userService.isLoggedIn()) {
      this.$router.push('/home');
    } else {
      this.$router.push('/api-products');
    }
  },
}
</script>

<style>
</style>
